import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Network from '../../../models/Network.js';
import ReactMarkdown from 'react-markdown'
// import ReactDom from 'react-dom'

import FilterListElement from '../list_elements/FilterListElement.js';
import LoadingListElement from '../list_elements/LoadingListElement.js';
import ReportListElement from '../list_elements/ReportListElement.js';
import GraphApiMeasureReportsInteractive from '../graphics/GraphApiMeasureReportsInteractive.js';
import TypeTag from '../tags/TypeTag.js';
import ImpactAttributeTag from '../tags/ImpactAttributeTag.js';
import './Module.css';

const key = process.env.REACT_APP_CLIENT_ACCESS_KEY;
const URLS = require("../../../urls.js");

const StatusCodes = require('../../../status-codes/status-codes.js')
const ErrorCodes = require('../../../error-codes/error-codes.js')

const MeasureGraphsModule = ({user, isSmallScreen}) => {
    const navigate = useNavigate();

    const [jsonData, setJsonData] = useState(null);
    const [measureMetadata, setMeasureMetadata] = useState(null);
    const [filterDict, setFilterDict] = useState(null);
    const [medicsData, setMedicsData] = useState(null);
    const [testMetadata, setTestMetadata] = useState(null);
    const [selectedIncident, setSelectedIncident] = useState(null);
    const [selectedReportData, setSelectedReportData] = useState(null);
    const [selectedTestResults, setSelectedTestResults] = useState(null);
    
    const graphParams = {
        width: 400,
        height: 400
    }

    // Function to handle report button click
    const handleReportButtonClick = (reportId) => {
        navigate('/report/' + reportId);
    };

    // Function to find the selected report data
    const getSelectedReportData = () => {
        if (!selectedIncident || !jsonData) return null;
        return jsonData.find(report => report.incident_number === selectedIncident);
    };

    // Function to get detailed report data from server
    const getOneReport = async (reportId) => {
        const url = URLS.GET_ONE_REPORT;
        const dict = {
            uid: user.uid,
            report_id: reportId,
            CLIENT_ACCESS_KEY: key
        };
        let responseData;

        await Network.post(url, dict, (response) => {
            responseData = response.data;
            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something
            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")
            } else {
                console.log("Unknown Error")
            }
        });
        return responseData;
    };

    // Function to get specific test results for a report and test
    const getOneReportTestResults = async (reportId, testName) => {
        const url = URLS.GET_ONE_REPORT_TEST_RESULTS;
        const dict = {
            uid: user.uid,
            report_id: reportId,
            test_name: testName,
            CLIENT_ACCESS_KEY: key
        };
        let responseData;

        await Network.post(url, dict, (response) => {
            responseData = response.data;
            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something
            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")
            } else {
                console.log("Unknown Error")
            }
        });
        return responseData;
    };

    // function that gets multiple reports from the server
    const getSeveralReportsMeasuresFiltered = async (desiredNumber, reportOffset, filterDict) => {
        
        const url = URLS.GET_SEVERAL_REPORTS_MEASURES_FILTERED;
        const dict = {
            uid: user.uid,
            number_of_reports: desiredNumber,
            offset: reportOffset,
            filter_dict: filterDict,
            CLIENT_ACCESS_KEY: key
        };

        let responseData;

        await Network.post(url, dict, (response) => {

            responseData = response.data;

            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something

            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")

            } else {
                console.log("Unknown Error")
            }
        });

        return responseData;
    };

    const getMeasureMetadata = async (desiredMeasure) => {
        
        const url = URLS.GET_MEASURE_METADATA;
        const dict = {
            uid: user.uid,
            measure_name: desiredMeasure,
            CLIENT_ACCESS_KEY: key
        };

        let responseData;

        await Network.post(url, dict, (response) => {

            responseData = response.data;

            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something

            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")

            } else {
                console.log("Unknown Error")
            }
        });

        return responseData;
    };

    const getAllAgencyMedics = async (agencyId) => {
        const url = URLS.GET_MEDICS_FOR_USER;
        const dict = {
            uid: user.uid,
            agency_id: agencyId,
            CLIENT_ACCESS_KEY: key
        };

        let responseData;

        await Network.post(url, dict, (response) => {
            responseData = response.data;

            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something
            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")
            } else {
                console.log("Unknown Error")
            }
        });

        return responseData;
    };

    const getTestMetadata = async (testId) => {
        const url = URLS.GET_ALL_TEST_METADATA_URL;
        const dict = {
            uid: user.uid,
            test_id: testId,
            CLIENT_ACCESS_KEY: key
        };

        let responseData;

        await Network.post(url, dict, (response) => {
            responseData = response.data;

            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something
            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")
            } else {
                console.log("Unknown Error")
            }
        });

        return responseData;
    };

    // Function to generate CSV data from reports
    const generateCSVData = (reports, status) => {
        if (!reports || reports.length === 0) return '';
        
        // Filter reports by status (passed/failed)
        // result is numeric: 1 = pass, 0 = fail, null/other = does not apply
        const filteredReports = reports.filter(report => {
            const result = report.result;
            if (status === 'passed') {
                return result === 1 || result === '1';
            } else if (status === 'failed') {
                return result === 0 || result === '0';
            }
            return true; // all reports if no specific status
        });

        if (filteredReports.length === 0) return '';

        // Define CSV headers
        const headers = [
            'Incident Number',
            'Unit Back in Service',
            'Result'
        ];

        // Generate CSV rows
        const csvRows = filteredReports.map(report => {
            // Convert numeric result to string
            // Handle both numeric and string representations
            const result = report.result;
            let resultText = '';
            if (result === 1 || result === '1') {
                resultText = 'Pass';
            } else if (result === 0 || result === '0') {
                resultText = 'Fail';
            } else {
                resultText = 'Does Not Apply';
            }

            return [
                report.incident_number || '',
                report.unit_back_in_service || '',
                resultText
            ];
        });

        // Combine headers and rows
        const csvContent = [headers, ...csvRows]
            .map(row => row.map(field => `"${String(field)}"`).join(','))
            .join('\n');

        return csvContent;
    };

    // Function to copy CSV data to clipboard
    const copyToClipboard = async (csvData, status) => {
        try {
            await navigator.clipboard.writeText(csvData);
            alert(`${status} reports copied to clipboard!`);
        } catch (err) {
            console.error('Failed to copy to clipboard:', err);
            alert('Failed to copy to clipboard. Please try again.');
        }
    };

    // Function to handle CSV export for passed reports
    const handleExportPassedReports = () => {
        if (!jsonData) {
            alert('No data available to export.');
            return;
        }
        const csvData = generateCSVData(jsonData, 'passed');
        if (csvData) {
            copyToClipboard(csvData, 'Passed');
        } else {
            alert('No passed reports found.');
        }
    };

    // Function to handle CSV export for failed reports
    const handleExportFailedReports = () => {
        if (!jsonData) {
            alert('No data available to export.');
            return;
        }
        const csvData = generateCSVData(jsonData, 'failed');
        if (csvData) {
            copyToClipboard(csvData, 'Failed');
        } else {
            alert('No failed reports found.');
        }
    };

    // get all medics from the server
    useEffect(() => {
        getAllAgencyMedics(user.uid)
            .then((data) => {
                setMedicsData(data);
            })
            .catch((error) => {
                console.log('Error:', error);
            });
    }, []);

    // get all test metadata from the server on component mount
    useEffect(() => {
        const getAllTestMetadata = async () => {
            try {
                const url = URLS.GET_ALL_TEST_METADATA_URL;
                const dict = {
                    uid: user.uid,
                    CLIENT_ACCESS_KEY: key
                };

                await Network.post(url, dict, (response) => {
                    if (Network.checkValidStatusAndResponse(response)) {
                        setTestMetadata(response.data);
                    } else {
                        console.log('Error fetching test metadata, status:', response.status);
                        // Set empty array as fallback
                        setTestMetadata([]);
                    }
                });
            } catch (error) {
                console.log('Error fetching test metadata:', error);
                // Set empty array as fallback
                setTestMetadata([]);
            }
        };

        getAllTestMetadata();
    }, []);

    // get report measures from the server
    useEffect(() => {
        // get the reports based on the current filterDict
        if (filterDict && filterDict.measureName) {
            getSeveralReportsMeasuresFiltered(5000, 0, filterDict) // max 5000 reports, no offset
                .then((data) => {
                    setJsonData(data); // TODO: add protection against API failure
                    console.log('Setting JSON data:', data);
                })
                .catch((error) => {
                    console.log('Error:', error);
                });
            getMeasureMetadata(filterDict.measureName)
                .then((data) => {
                    setMeasureMetadata(data); // TODO: add protection against API failure
                    console.log('Setting measure metadata:', data);
                })
        }
    }, [filterDict]);

    // get detailed report data when incident is selected
    useEffect(() => {
        if (selectedIncident && getSelectedReportData()) {
            const reportId = getSelectedReportData().report_id;
            getOneReport(reportId)
                .then((data) => {
                    if (data && data.length > 0) {
                        console.log('Setting selected report data:', data[0]);
                        setSelectedReportData(data[0]);
                    }
                })
                .catch((error) => {
                    console.log('Error fetching detailed report data:', error);
                    setSelectedReportData(null);
                });
        } else {
            setSelectedReportData(null);
        }
    }, [selectedIncident, jsonData]);

    // get test results when both incident and measure are selected
    useEffect(() => {
        if (selectedIncident && getSelectedReportData() && measureMetadata && measureMetadata[0]) {
            const reportId = getSelectedReportData().report_id;
            const testName = measureMetadata[0].test_name;
            getOneReportTestResults(reportId, testName)
                .then((data) => {
                    console.log('Setting selected test results:', data);
                    setSelectedTestResults(data);
                })
                .catch((error) => {
                    console.log('Error fetching test results:', error);
                    setSelectedTestResults(null);
                });
        } else {
            setSelectedTestResults(null);
        }
    }, [selectedIncident, measureMetadata, jsonData]);

    
    return (
        <div className={isSmallScreen ? "standard-module-screen-small" : "standard-module"}>
            <FilterListElement
                medicsData={medicsData}
                testMetadata={testMetadata}
                filterState={
                    {
                        date: ["year"],
                        read: ["both"],
                        finished: ["both"]
                    }
                }
                dictUpdateHandler={setFilterDict}
                showClearButton={false}
                filterDropdownsVisible={{
                    // date: true,
                    medics: true,
                    typeTags: true,
                    measures: true
                }}
            />
            <div>
                {jsonData ? (
                    <h2 className='module-title'>{measureMetadata[0].issue_message}</h2>
                ) : (
                    <div></div>
                )}
            </div>
            <div>
                {measureMetadata ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                        <ImpactAttributeTag attributeType={measureMetadata[0].impact_attribute || "measure"} isButton={false} />
                        <TypeTag reportType={measureMetadata[0].test_type} isButton={false} />
                    </div>
                ) : (
                    <h4 className='module-subtitle'>Select data above to visualize it.</h4>
                )}
            </div>
            <div style={{ textAlign: 'left', paddingBottom: '10px' }}>
                {measureMetadata ? (
                    <ReactMarkdown>{measureMetadata[0].long_description}</ReactMarkdown>
                ) : (
                    <div></div>
                )}
            </div>
            {/* Selected Report Display */}
            {selectedIncident && getSelectedReportData() && (
                <div style={{ marginBottom: '20px' }}>
                    <ReportListElement
                        reportId={getSelectedReportData().report_id}
                        reportNumber={selectedReportData ? selectedReportData.pcr_number : getSelectedReportData().report_number}
                        incidentNumber={selectedReportData ? selectedReportData.incident_number : getSelectedReportData().incident_number}
                        numberOfIssues={selectedReportData ? selectedReportData.number_issues : getSelectedReportData().number_of_issues}
                        numberOfSuggestions={selectedReportData ? selectedReportData.number_suggestions : getSelectedReportData().number_of_suggestions}
                        reportType={selectedReportData ? selectedReportData.report_type : getSelectedReportData().report_type}
                        incidentTime={selectedReportData ? selectedReportData.unit_back_in_service : getSelectedReportData().incident_time}
                        read={selectedReportData ? selectedReportData.report_marked_read : getSelectedReportData().report_marked_read}
                        finished={selectedReportData ? selectedReportData.report_marked_finished : null}
                        narrativeSummarized={selectedReportData ? selectedReportData.narrative_summarized : null}
                        result={selectedTestResults && selectedTestResults.length > 0 ? selectedTestResults[0].result : null}
                        failureMode={selectedTestResults && selectedTestResults.length > 0 ? selectedTestResults[0].failure_mode : null}
                        verbose={true}
                        onButtonClick={handleReportButtonClick}
                    />
                </div>
            )}
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                {jsonData ? (
                    <div>
                        
                        {/* Compliance Legend */}
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            gap: '20px', 
                            backgroundColor: 'white',
                            borderRadius: '4px',
                            fontSize: '14px'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <div style={{ 
                                    width: '16px', 
                                    height: '3px', 
                                    backgroundColor: 'black',
                                    borderRadius: '1px'
                                }}></div>
                                <span>Group Compliance</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <div style={{ 
                                    width: '16px', 
                                    height: '3px', 
                                    backgroundColor: '#0C7FFA',
                                    borderRadius: '1px'
                                }}></div>
                                <span>Medic Compliance</span>
                            </div>
                        </div>
                        <GraphApiMeasureReportsInteractive 
                            data={jsonData} 
                            graphParams={graphParams}
                            onIncidentSelect={setSelectedIncident}
                        />
                        {/* <GraphApiMeasureReports data={jsonData} graphParams={graphParams}/> */}
                    </div>
                ) : (
                    <div></div>
                )}
            </div>
            
            {/* CSV Export Buttons */}
            {jsonData && (
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    gap: '16px', 
                    marginTop: '20px',
                    padding: '16px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef'
                }}>
                    <button
                        onClick={handleExportPassedReports}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#28a745',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            transition: 'background-color 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#218838'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#28a745'}
                    >
                        📋 Copy Passed Reports (CSV)
                    </button>
                    <button
                        onClick={handleExportFailedReports}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#dc3545',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            transition: 'background-color 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#c82333'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#dc3545'}
                    >
                        📋 Copy Failed Reports (CSV)
                    </button>
                </div>
            )}
            
            {/* Vega Tree Diagram Test Component */}
            {/* <GraphTreeTest /> */}
        </div>
    );
}

export default MeasureGraphsModule;